import { useTranslation } from 'react-i18next'

import { NewsboardPostAction } from '../NewsboardPostAction'
import { QA_NAME_VIEWS_ACTION } from '../NewsboardPostFooter.constants'
import { POST_REPORTS_VIEWS_TAB } from '../NewsboardPostReport'

import ViewsIcon from '../../../../../icons/open-eye.svg'

function NewsboardPostViews({ data, onOpenReport }) {
  const { t } = useTranslation()

  const canViewReport = data?.permissions.can_view_post_report

  function handleOpenReport() {
    if (canViewReport) {
      onOpenReport?.(POST_REPORTS_VIEWS_TAB)
    }
  }

  return (
    <NewsboardPostAction
      Icon={ViewsIcon}
      disabledAction={!canViewReport}
      qaName={QA_NAME_VIEWS_ACTION}
      title={t('Newsboard.ViewsActionKey', { count: data?.counters?.viewers })}
      tooltip={t('Newsboard.ViewsActionTooltipKey')}
      onClick={handleOpenReport}
    />
  )
}

export default NewsboardPostViews
